import React from "react";
import PageNotFound from "../../../components/shared/page-not-found";
import withLayout from "../../../components/desktop/layout/component";

const NotFound = () => {
    return <PageNotFound />;
};

export default withLayout(NotFound);
